import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import {LoginService} from '../../../login-service';

@Component({
  selector: 'app-skills1',
  templateUrl: './category1.component.html'
  
})
export class Category1Component implements OnInit {
  count:any
  p:any
  showeditview:boolean=false;
  showadd:boolean=false;
  [x: string]: any;
category:any;
subcategory:any;
addcategory:boolean=false;
categorieslist:any=[];
categoryListDetails:any;
parentcategoryList:any;
menuData:any;
message:any;
type:any;
viewed:boolean=false;
    description: any;
  searchText: any;
  subCategorys=[];
subcategorieslength:any=[];
  pager: {
    totalItems: number; currentPage: number; pageSize: number; totalPages: number; startPage: number;
    endPage: number; startIndex: number; endIndex: number;
    pages: number[];
  };
  searchWord: string = "";
  pagedItems: any;
  SearchList:any;
  roleID:string;
  userID:string;
  currentpage: number=1;
  MenuPermissions: string;
  rolesList: any;
  usertypeid:string;
  selectedcategoryListid=[];
  dynamicRows:any=10;
  rowsOnPageSet:any=[];
  rowsOnPage:any
  rowCount:any
  savefilter:any;
  SubCategories=[]
  categoryID:any;
  editsub:boolean=false;
  toeditsub:any;
  constructor(private loginService:LoginService) { this.userID=localStorage.getItem("userID");
  this.roleID=localStorage.getItem("roleID");
  // this.menuData=localStorage.getItem("menuData");
  this.MenuPermissions=localStorage.getItem("MenuPermissions");
  
  this.usertypeid=localStorage.getItem("userTypeid");
  this.GetMenusByUserType(3);}

  ngOnInit(): void {
    this.loginService.getselectpage(10)
    this.getcategories();
    this.GetRoles();
  
  }
  getcategories() {
    this.subcategoriesList=[];
    this.subcategorieslength=[]
    this.loginService.GetCategories(this.usertypeid,0).subscribe(data=>
      {
        this.parentcategoryList=JSON.parse(data['_body']);
       console.log(this.parentcategoryList)
          this.loginService.GetSubcategories().subscribe(data=>
            {
              this.subcategoriesList=JSON.parse(data['_body']);
            //  console.log(this.savefilter.length)
            for(var i=0;i<this.parentcategoryList.length;i++){
              // console.log(this,this.parentcategoryList[i])
              var subcatlist=this.subcategoriesList.filter(x=>x.parentid==this.parentcategoryList[i].id)
              console.log(subcatlist)
              this.categorieslist.push({
                id:this.parentcategoryList[i].id,
                category:this.parentcategoryList[i].category,
                description:this.parentcategoryList[i].description,
                parentid:this.parentcategoryList[i].parentid,
                isactive:this.parentcategoryList[i].isactive,
                noOfSubcategories:subcatlist.length
              })
           
          // var number=this.subcategoriesList.length;
          // this.subcategorieslength.push(number);
            }
            this.assigndynamicarray(this.categorieslist)
            this.categoryListDetails=this.categorieslist;
            this.savefilter=this.categorieslist
            console.log(this.categorieslist)
       
        
       
        if(this.categoryListDetails.length>0){
          this.setPage(1);
        }
      })
      })
  }
  assigndynamicarray(categorylist)
  {
    this.dynamicRows=10
    this.rowsOnPageSet=[];
    this.rowCount = categorylist.length;
    console.log(this.rowCount,this.dynamicRows)
    while (this.dynamicRows < this.rowCount) {
      this.rowsOnPageSet.push(this.dynamicRows);
      this.dynamicRows = this.dynamicRows + 10;
      console.log(this.rowsOnPageSet)
    }
    if (!this.rowsOnPageSet.includes(this.rowCount))
      this.rowsOnPageSet.push(this.rowCount);
    if (this.rowsOnPageSet.length === 1) {
      if (this.rowsOnPageSet[0] <= 10)
        this.rowsOnPage = this.rowsOnPageSet[0];
    }
    this.rowsOnPage = this.rowsOnPageSet[0];
  }
  Addcategories(){
    this.showadd=true;
    this.showeditview=false;
    this.addcategory=true;
    this.type="New";
  }
  submit(){
  
  }
// }
editSubCategory(c){
  this.toeditsub=c;
  this.subcategory=c.category;
  this.editsub=true;
}
editchangesub(){
  let indexCate=this.SubCategories.find(val=>val.id==this.toeditsub.id);
const index1: number = this.SubCategories.indexOf(indexCate);
this.SubCategories[index1].category=this.subcategory
this.editsub=false;
this.subcategory=""
}

deleteSubCategory(c) {
  
let indexCate=this.SubCategories.find(val=>val.category==c.category);
const index1: number = this.SubCategories.indexOf(indexCate);
  
  
if(c.id!=0){
  event.stopPropagation();
   Swal.fire({
     title: 'Are you sure?',
     text: 'You want to delete '+c.category ,///
     icon: 'warning',
     showCancelButton: true,
     confirmButtonText: 'Yes',
     cancelButtonText: 'No'
   }).then((result) => {
     if (result.value) {
      if (index1 !== -1) {
        this.SubCategories.splice(index1, 1);
      }
        this.delete(c.id,'d');
     } else if (result.dismiss === Swal.DismissReason.cancel) {
 
     }
   })
  }
  else{
    if (index1 !== -1) {
      this.SubCategories.splice(index1, 1);
    }
  }
}

GetRoles(){
    this.loginService.GetRoles(this.usertypeid).subscribe(data=>
      {  
              this.rolesList=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
  let filteRole=this.rolesList.filter(x=>x.RoleID.toString()==this.roleID.toString())

  if(filteRole.length>0){
    this.MenuPermissions=JSON.parse(filteRole[0].MenuJson);

  }
  });
  }
  GetMenusByUserType(userTypeID){
    this.loginService.GetMenusByUserType(userTypeID).subscribe(data=>
        {
    this.menuData=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
  
    let tempdata=this.menuData;
  
    this.menuData=tempdata.filter(x=>x.menu_name.toString().toLowerCase()==='category');
  
    if(this.menuData.length>0)
      {
    this.menuName=this.menuData[0]["menu_name"];
    this.menuID=this.menuData[0]["menu_id"];
      }
    

      
    
        });
        }
  
savecategories()
{
if(this.category==""||this.category==undefined||this.SubCategories.length==0||this.SubCategories.length==undefined){return;}
  const json ={
    categoryparm :this.category,
    descriptionparm :"",
    parentidparm:0,
    createdbyparm: 'admin',
    subcategory:this.SubCategories,
    id:this.categoryID
  };

  this.loginService.SaveCategories(json).subscribe((dataJson) => {

    if (dataJson['_body'].toString() === 'true') {
   
    // Swal.fire("Saved Successfully");
    this.loginService.showSuccess("Saved successfully!",'');
    }
 this.getcategories();
 
 this.editsub=false;
    });
    

}


edit(row){
  this.showeditview=true;
  this.showadd=false;
  this.type="Edit";
  this.addcategory=true;
  this.categoryID=row.id;
  this.category=row.category;
  
    this.loginService.GetCategories(this.usertypeid,row.id).subscribe(data=>
      {
        this.SubCategories=JSON.parse(JSON.stringify(JSON.parse(data['_body'])));
      })
   
  this.subcategory=row.subcategory;
}
viewcategory(row){
this.showeditview=true;
this.showadd=false;
  this.type="View";
  this.addcategory=true;
  this.viewed=true;
  this.category=row.category;
  this.loginService.GetCategories(this.usertypeid,row.id).subscribe(data=>
    {
      this.SubCategories=JSON.parse(data['_body']);
    })
  this.subcategory=row.subcategory;
}
selectRow(id,e){
  if(e.target.checked){
   this.checked=true;;
   this.selectedcategoryListid.push(e.target.id)
  }
  else{
   var index = this.selectedcategoryListid.indexOf(e.target.id);
  this.checked=false;
  this.selectedcategoryListid.splice(index,1)
  }
}
DeleteSelected(){
 if(this.selectedcategoryListid.length==0){
   return;
 }
 else{
   event.stopPropagation();
   Swal.fire({
     title: 'Are you sure?',
     text: 'You want to delete the selected rows' ,///
     icon: 'warning',
     showCancelButton: true,
     confirmButtonText: 'Yes',
     cancelButtonText: 'No'
   }).then((result) => {
     if (result.value) {
       this.deleterows(this.selectedcategoryListid);//
     } else if (result.dismiss === Swal.DismissReason.cancel) {
 
     }
   })
 }
}
deleterows(list){
for(var i=0;i<list.length;i++){
 this.delete(list[i],'d');
 this.selectedcategoryListid=[];
}
}
deletecategory(row,isactive,text){

  event.stopPropagation();
  Swal.fire({
    title: 'Are you sure?',
    text: 'You want to '+text+' this category:' ,///
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'No'
  }).then((result) => {
    if (result.value) {
      this.delete(row.id,isactive);
    } else if (result.dismiss === Swal.DismissReason.cancel) {

    }
  })

}

delete(ID,isactive) {
  const json={
    id:ID,
    isactive:isactive
  }
  this.loginService.Deletecategory(json).subscribe(data => {
    if(isactive=='d'){
      this.loginService.showSuccess("Deleted Successfully","");
    
    }
    else if(isactive=='y'){
    this.loginService.showSuccess("Activated Successfully","");
    
    }
    else{
    this.loginService.showSuccess("Deactivated Successfully","");
    
    }    this.getcategories();
    setTimeout(() => {
      this.message = "";
    }, 1000);
  // this.getFares();
  // this.setPage(1);
  })
}
changepagination(page:number){
  this.count=this.rowsOnPage
  this.loginService.getselectpage(this.rowsOnPage)
  this.loginService.getPager(this.usersListDetails.length, page);
  this.setPage(page)
}

setPage(page: number) {

   this.p=page;
  this.pager = this.loginService.getPager(this.categoryListDetails.length, page);
  this.pagedItems = this.categoryListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
  this.count=this.pager.pageSize
  this.categorieslist = this.categoryListDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);

}



Searchtext(){
  this.categorieslist = this.savefilter;
 
      let tempCompany = this.categorieslist.filter(
        (item) => {
          return (
            (item.category !== null && item.category.toLowerCase().indexOf(this.searchText.toLowerCase().trim()) > -1)
           
          );
        }
  
      );
      this.categorieslist = tempCompany;
      this.assigndynamicarray(tempCompany)
      // if(this.searchText==""){
      //   this.getcategories();
      //   this.assigndynamicarray(this.parentcategoryList)
      // }
      if(this.searchText !== ""){
        this.categoryListDetails = tempCompany;
        this.setPage(1);
    }else{
        this.categoryListDetails = this.savefilter;      
        this.assigndynamicarray(this.categorieslist)
  
        this.setPage(1);
    }
    
}
CancelCategory(){
  this.addcategory=false;
  this.editsub=false;
  this.category="";
  this.subcategory="";
  this.subCategorys=[];
  this.SubCategories=[];
  this.getcategories();
}
AddSubCategorys(){
 if(this.subcategory==""||this.subcategory==undefined)
 {
   return;
 }
  const json={
    id:0,
    category:this.subcategory
  }
  this.SubCategories.push(json)
this.subcategory="";

}

}
